export const PROPERTY_ATTRIBUTE_CATEGORY_LISTING_FIELD = 'listingField';
export const PROPERTY_ATTRIBUTE_CATEGORY_FEATURE = 'feature';

export const PROPERTY_ATTRIBUTE_CATEGORY_OPTION_ITEMS = [
  PROPERTY_ATTRIBUTE_CATEGORY_LISTING_FIELD,
  PROPERTY_ATTRIBUTE_CATEGORY_FEATURE,
].map((category) => ({
  label: category,
  value: category,
}));

export const PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_OVERRIDE = 'override';
export const PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_UPDATE = 'update';
export const PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_DEFAULT = 'default';
export const PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_NEITHER = 'neither';

export const PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_OPTION_ITEMS = [
  PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_OVERRIDE,
  PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_UPDATE,
  PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_NEITHER,
].map((behavior) => ({
  label: behavior,
  value: behavior,
}));

export const PROPERTY_ATTRIBUTE_LEVEL_APARTMENT = 'apartment';
export const PROPERTY_ATTRIBUTE_LEVEL_APARTMENT_BUILDING = 'apartmentBuilding';
export const PROPERTY_ATTRIBUTE_LEVEL_FLOOR_PLAN = 'floorPlan';
